import { render, staticRenderFns } from "./PonudaEdit.vue?vue&type=template&id=12e56e79&scoped=true"
import script from "./PonudaEdit.vue?vue&type=script&lang=js"
export * from "./PonudaEdit.vue?vue&type=script&lang=js"
import style0 from "./PonudaEdit.vue?vue&type=style&index=0&id=12e56e79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e56e79",
  null
  
)

export default component.exports